import {AbstractModel} from '../abstract-model';
import {SimpleStat} from './simple-stat';
import {PartnerHistory} from './partner-history';
import {LeadOverview} from './lead-overview';

export class PartnerStat extends AbstractModel {
  currentYearToDate: SimpleStat = new SimpleStat();
  lastYearToDate: SimpleStat = new SimpleStat();
  history: PartnerHistory = new PartnerHistory();
  currentMonth: LeadOverview = new LeadOverview();

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.currentYearToDate) {
      this.currentYearToDate = new SimpleStat().deserialize(input.currentYearToDate);
    }

    if (input.lastYearToDate) {
      this.lastYearToDate = new SimpleStat().deserialize(input.lastYearToDate);
    }

    if (input.history) {
      this.history = new PartnerHistory().deserialize(input.history);
    }

    if (input.currentMonth) {
      this.currentMonth = new LeadOverview().deserialize(input.currentMonth);
    }

    return this;
  }
}
